<template>
  <transition name="fade">
    <div v-if="show" class="popup_box" style="display: block" @click.self="show = false">
      <div class="popup delete_category">
        <span class="page_title">Удалить поставщика [{{supplier_on_delete.id}}] {{supplier_on_delete.name}}  ?</span>
        <span class="close_popup" @click="close()"></span>
        <button class="btn" @click="close()">Отмена</button>
        <button class="btn empty" @click="confirm()">Удалить</button>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  name: 'DeleteSupplierModal',
  computed: {
    ...mapState('suppliers', ['supplier_on_delete', 'show_delete_supplier_modal']),
    show: {
      get () {
        return this.show_delete_supplier_modal
      },
      set (value) {
        this.setShowDeleteSupplierModal(value)
      }
    }
  },
  methods: {
    ...mapActions('suppliers', ['deleteSupplier']),
    ...mapMutations('suppliers', ['setShowDeleteSupplierModal', 'setSupplierOnDelete']),
    close () {
      this.setSupplierOnDelete(null)
      this.show = false
    },
    confirm () {
      this.deleteSupplier(this.supplier_on_delete.id)
      this.close()
    }
  }
}
</script>

<style scoped>

</style>
